
import { prop, define, useCraftProp } from "@/components/builder/utils";
import ContentEditable from "@/components/builder/utils/ContentEditable";

import BasePreview from "../../base";

function UnsubscribeFormConfirmationPreview({ ...props }) {
  const { value, setValue } = useCraftProp('content')

  return <BasePreview {...props}>
    <ContentEditable
      html={value}
      onChange={e => setValue(e.target.value)}
      tagName='p'
    />
  </BasePreview>
}

function UnsubscribeFormConfirmationHTML({ content, altContent, attributes }) {
  return <p {...attributes}>
    {`{{#if @params.email}}`}
    {content}
    {`{{else}}`}
    {altContent}
    {`{{/if}}`}
  </p>
}

export default define('unsub-form-confirmation', UnsubscribeFormConfirmationPreview, UnsubscribeFormConfirmationHTML)
  .property(prop.stylePattern())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .property(prop.text('Alternative content', 'altContent').category('default').own())
  .defaultProps({
    textAlign: { horizontal: 'center' },
    fontSize: 'lg',
    textColor: 'gray-900',
    size: { width: 'w-full' },
  })
  .build()
